import React from "react";
import RevenueReport from "./RevenueReport";

const RevenueRecognition: React.FC = () => {
  return (
    <RevenueReport revenueType="revenue"></RevenueReport>
  )
}

export default RevenueRecognition;